import {BitMapMultiplier} from "./BitmapMultiplier";
import {RoadKillSymbolStates} from "./enums/RoadKillEnums";
import {RoadKillGameAssets} from "../RoadKillGameAssets";
import {gsap} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class Multiplier extends PIXI.Container {
    constructor(fontStyle?: string, fontSize?: number, preFixedText?: string, postFixedText?: string) {
        super();
        this.init(fontStyle, fontSize, preFixedText, postFixedText);
    }

    private _multiplier: BitMapMultiplier;

    get multiplier(): BitMapMultiplier {
        return this._multiplier;
    }

    private _showIfDefaultValue: boolean = false;

    get showIfDefaultValue(): boolean {
        return this._showIfDefaultValue;
    }

    set showIfDefaultValue(value: boolean) {
        this._showIfDefaultValue = value;
    }

    get value(): number {
        return this._multiplier.value;
    }

    set value(value: number) {
        this._multiplier.value = value;
        if (this._showIfDefaultValue) {
            this.show();
        } else if (value > 1) {
            this.show();
        } else if (value === 0) {
            this.setVisibility(false);
        }
    }

    public setFontSize(value: number): void {
        this._multiplier.fontSize = value;
    }

    public setState(state: RoadKillSymbolStates): void {
        Logger.logDev("Multiplier set State called : ", state);
        if (state === RoadKillSymbolStates.NO_WIN && this._multiplier.tint === 16777215) {
            this._multiplier.tint = 0x482c03;
        } else {
            this._multiplier.tint = 16777215;
        }
    }

    public setCenter(x: number, y: number): void {
        this._multiplier.anchor = new PIXI.Point(x, y);
    }

    public show(): gsap.core.Tween {
        return this.setVisibility(true);
    }

    public hide(): gsap.core.Tween {
        return gsap.to(this._multiplier, 0.1, {
            alpha: 0, onComplete: () => {
                this.value = 1;
            }
        });
    }

    public setVisibility(shouldVisible: boolean): gsap.core.Tween {
        return gsap.to(this._multiplier, 0.1, {alpha: shouldVisible ? 1 : 0});
    }

    public reset(): void {
        this.hide();
    }

    private init(fontStyle?: string, fontSize?: number, preFixedText?: string, postFixedText?: string): void {
        this._multiplier = new BitMapMultiplier(fontStyle || RoadKillGameAssets.BITMAP_FONT_WIN_COUNT_UP, fontSize || 16, preFixedText, postFixedText);
        this._multiplier.value = 1;
        this._multiplier.alpha = 0;
        this.addChild(this._multiplier);
    }

}